import { routes } from '../mappers/urls';

export const ignoredRoutes = [
  routes.GUEST_PORTAL_V2.split('/:')[0],
  routes.GUEST_REGISTRATION_V2.split('/:')[0],
  routes.FEEDBACK_V2.split('/:')[0],
  routes.ACCEPT_INVITE,
  routes.FORGOTPASSWORD,
  routes.CREATENEWPASSWORD,
];

export const normalizeRoutes = (name: string): string =>
  name.toLowerCase().replace(/-/g, '_');
